<template>

    <div class="modale" :class="{'visible': opened}">
        <dialog class="dialog dialog--login">

            <div class="dialog__heading">

                <h3 class="dialog-title">Se connecter</h3>

                <button class="dialog__heading__close"
                    type="button"
                    v-on:click="hideAuthModal()">
                    <i class="fa fa-close"></i>
                </button>
            </div>

            <div class="dialog__body">
                <div class="woocommerce">
                    <form class="form woocommerce-form woocommerce-form-login" method="post" :action="$config.LOGIN_URL">
            
                        <p class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
                            <label for="username">Utilisateur ou adresse e-mail&nbsp;<span class="required">*</span></label>
                            <input type="text" class="woocommerce-Input woocommerce-Input--text input-text" name="username" id="username" autocomplete="username" value="">
                        </p>
                        <p class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
                            <label for="password">Mot de passe&nbsp;<span class="required">*</span></label>
                            <input class="woocommerce-Input woocommerce-Input--text input-text" type="password" name="password" id="password" autocomplete="current-password" />
                            <span class="lost-password-link">
                                <a href="/my-account/lost-password/">Mot de passe oublié?</a>
                            </span>
                        </p>
                        <p class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
                            <label class="woocommerce-form__label woocommerce-form__label-for-checkbox woocommerce-form-login__rememberme">
                                <input class="woocommerce-form__input woocommerce-form__input-checkbox" name="rememberme" type="checkbox" id="rememberme" value="forever"> <span>Se souvenir de moi</span>
                            </label>
                        </p>
                        
                        <p class="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide ad-form-login-submit">
                            <input type="hidden"
                                name="_wp_http_referer"
                                :value="$config.LOGIN_REFERER">
                            <button type="submit" class="woocommerce-button button woocommerce-form-login__submit" name="login" value="Log in">Se connecter</button>
                        </p>

                        <p class="create-account-link">
                            <a :href="$config.CREATE_ACCOUNT_LINK" target="_blank" v-html="$config.CREATE_ACCOUNT_TEXT" />
                        </p>
                        
                    </form>
                </div>               
            </div>

        </dialog>
    </div>

</template>

<script>
import Vue from 'vue';

export const LOGIN_EVENT = 'loggedIn'

export const LoginBus = new Vue();

export let LOGIN_MODALE_OPENED = false;

export default {

    data() {
        return {
            opened: false
        }
    },

    methods: {

        showAuthModal: function() {

            if ( LOGIN_MODALE_OPENED ) {
                return
            }

            this.opened = LOGIN_MODALE_OPENED = true
        },

        hideAuthModal: function() {
            this.opened = LOGIN_MODALE_OPENED = false
        }
    },

    created() {
        LoginBus.$on(LOGIN_EVENT, () => this.showAuthModal())
    },

    name: 'LoginModale'
}
</script>

<style scoped>

.ad-form-login-submit {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
}

.ad-form-login-submit [type="submit"] {
    flex: 1;
    float: none;
    margin-right: 0;
}

.create-account-link,
.lost-password-link {
    display: block;
    font-size: 90%;
    margin: 4px 0;
}

.create-account-link {
    text-align: center;
}
.lost-password-link {
    text-align: right;
}

</style>
